/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSuperstackingSettingsInternalRequest} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/superstacking.pb'
import {GetSuperstackingSettingsResponse} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/superstacking.pb'


export const getSuperstackingSettingsInternal = (request: GetSuperstackingSettingsInternalRequest, options?: CashRequestOptions) => post<GetSuperstackingSettingsInternalRequest, GetSuperstackingSettingsResponse>("/2.0/cash/get-superstacking-settings-internal", request, {...options, rejectOnError: true })